'use strict';

class Phones {
	constructor(props = {}) {
		console.log('Phones::constructor(%o)', props);
		let _that = this;

		_that.filter = {
			buttons: document.querySelectorAll('.phone-filter-holder .filter-value'),
			default_class: 'btn-default',
			active_class: 'btn-grey_dark'
		};

		_that.form_filters = {
			manufacturer: [],
			condition: [],
			has_esim: [],
		};

		_that.phones = {
			holder: document.getElementById('phones_holder'),
			all_phones: document.querySelectorAll('#phones_holder .phone'),
			byod: document.querySelector('#phones_holder .byod')
		};

		_that.sorting = {
			priority: document.getElementById('sort_by_priority'),
			price: document.getElementById('sort_by_price'),
			name: document.getElementById('sort_by_name'),
			icon: document.querySelector('.icon-arrow'),
			active_class: 'active-sort',
			icon_asc_class: 'icon-down',
			icon_desc_class: 'icon-up'
		};

		_that = Object.assign(this, props);

		_that.filter.buttons.forEach((element) => {
			if (element.classList.contains(_that.filter.active_class)) {
				if (element.dataset.filterValue !== '') {
					_that.form_filters[element.dataset.filter].push(element.dataset.filterValue);
				}
			}
		});
		_that.filterPhones(_that.form_filters);

		_that.pageEvents();
	}

	filterPhones(filters) {
		let _that = this;

		_that.phones.all_phones.forEach((element) => {
			element.classList.remove('hidden');
		});

		Object.entries(filters).forEach(([key, filter]) => {
			if (filter.length > 0) {
				_that.phones.all_phones.forEach(phone => {
					if (!filter.includes(phone.attributes['data-filter_' + key].value)) {
						phone.classList.add('hidden');
					}
				});
			}
		});
	}

	isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

	sortByAttrs(fields, sort_order) {
		let _that = this;

		return Array.from(_that.phones.all_phones).sort((a, b) => {
			let sorted_result = 0;

			for (let i = 0;i < fields.length;i++) {
				let missing_attr = false;

				if (sort_order === 'desc') {
					let temp_a = a;
					a = b;
					b = temp_a;
				}

				let a_val = a.attributes[fields[i]].value;
				let b_val = b.attributes[fields[i]].value;

				if (typeof a_val === 'undefined' || a_val === false || (typeof b_val === 'undefined' || b_val === false)) {
					missing_attr = true;
				} else {
					a_val = _that.isNumeric(a_val) ? parseFloat(a_val) : a_val.toUpperCase();
					b_val = _that.isNumeric(b_val) ? parseFloat(b_val) : b_val.toUpperCase();
				}

				if (missing_attr || a_val === b_val) {
					sorted_result = 0;
				} else {
					sorted_result = a_val < b_val ? -1 : 1;
				}

				if (sorted_result !== 0) {
					break;
				}
			}

			return sorted_result;
		});
	}

	sortPhones(trigger_element, sorting_levels, inverted) {
		let _that = this;

		const sort_by = document.querySelectorAll('[id^="sort_by_"]');
		if (sort_by.length > 0) {
			sort_by.forEach((element) => {
				if (element !== trigger_element) {
					element.classList.remove(_that.sorting.active_class);
					element.dataset.filterOrder = 'asc';
				}
			});
		}

		trigger_element.classList.add(_that.sorting.active_class);

		trigger_element.querySelector('.' + _that.sorting.icon.classList[0]).classList.remove(_that.sorting.icon_asc_class, _that.sorting.icon_desc_class);

		let sort_order = trigger_element.dataset.filterOrder;
		if (sort_order === 'asc') {
			trigger_element.dataset.filterOrder = 'desc';
			trigger_element.querySelector('.' + _that.sorting.icon.classList[0]).classList.add(_that.sorting.icon_desc_class);
			sort_order = inverted ? 'desc' : 'asc';
		} else {
			trigger_element.dataset.filterOrder = 'asc';
			trigger_element.querySelector('.' + _that.sorting.icon.classList[0]).classList.add(_that.sorting.icon_asc_class);
			sort_order = inverted ? 'asc' : 'desc';
		}

		const sorted = _that.sortByAttrs(sorting_levels, sort_order);
		sorted.forEach((element) => {
			_that.phones.holder.insertAdjacentElement('beforeend', element);
		});
		_that.phones.holder.insertAdjacentElement('beforeend', _that.phones.byod);
	}

	pageEvents() {
		let _that = this;

		// use the same logic as in phones.php ( priority -> name -> price ) Ref: TELLOPHONESORTORDER
		if (_that.sorting.priority) {
			_that.sorting.priority.addEventListener('click', (event) => {
				_that.sortPhones(
					_that.sorting.priority,
					['data-filter_priority', 'data-filter_name', 'data-filter_discount_price'],
					true
				);
			});
		}

		if (_that.sorting.price) {
			_that.sorting.price.addEventListener('click', (event) => {
				_that.sortPhones(
					_that.sorting.price,
					['data-filter_discount_price', 'data-filter_priority', 'data-filter_name'],
					false
				);
			});
		}

		if (_that.sorting.name) {
			_that.sorting.name.addEventListener('click', () => {
				_that.sortPhones(
					_that.sorting.name,
					['data-filter_name', 'data-filter_priority', 'data-filter_discount_price'],
					false
				);
			});
		}

		_that.filter.buttons.forEach((filter_button) => {
			filter_button.addEventListener('click', (event) => {
				const current_filter = filter_button.dataset.filter;
				const current_filter_value = filter_button.dataset.filterValue;

				if (current_filter_value !== '') {
					if (event.ctrlKey) {
						filter_button.classList.remove(_that.filter.default_class);
						filter_button.classList.add(_that.filter.active_class);

						if (_that.form_filters[current_filter].length > 0) {
							if (!_that.form_filters[current_filter].includes(current_filter_value)) {
								_that.form_filters[current_filter].push(current_filter_value);
							} else {
								const index = _that.form_filters[current_filter].indexOf(current_filter_value);
								_that.form_filters[current_filter].splice(index, 1);

								filter_button.classList.remove(_that.filter.active_class);
								filter_button.classList.add(_that.filter.default_class);
							}
						} else {
							_that.form_filters[current_filter] = [current_filter_value];
						}

						_that.filterPhones(_that.form_filters);
					} else {
						_that.form_filters[current_filter] = [current_filter_value];

						const filter_buttons = Array.from(_that.filter.buttons).filter((element) => {
							return element.dataset.filter === current_filter && element.dataset.filterValue !== current_filter_value;
						});
						filter_buttons.forEach((element) => {
							element.classList.remove(_that.filter.active_class);
							element.classList.add(_that.filter.default_class);
						});

						filter_button.classList.remove(_that.filter.default_class);
						filter_button.classList.add(_that.filter.active_class);

						_that.filterPhones(_that.form_filters);
					}
				} else {
					_that.form_filters[current_filter] = [];

					const filter_buttons = Array.from(_that.filter.buttons).filter((element) => {
						return element.dataset.filter === current_filter && element.dataset.filterValue !== '';
					});
					filter_buttons.forEach((element) => {
						element.classList.remove(_that.filter.active_class);
						element.classList.add(_that.filter.default_class);
					});

					filter_button.classList.remove(_that.filter.default_class);
					filter_button.classList.add(_that.filter.active_class);

					_that.filterPhones(_that.form_filters);
				}

				// Update the URL based on the filters.
				// The URL order is the one from the form_filters option.
				let url_string = '/phones';
				let url_params = {};
				Object.entries(_that.form_filters).forEach(([key, filter]) => {
					if (filter.length) {
						if (key === 'has_esim' && filter[0] !== '') {
							url_params['esim'] = filter[0];
						} else {
							const filter_string = filter.filter(filter => filter !== '').join(',');
							if (filter_string !== '') {
								url_string += `/${filter_string}`;
							}
						}
					}
				});

				const new_url = url(url_string, url_params, true);
				if (new_url !== window.location.href) {
					window.history.pushState(_that.form_filters, '', new_url);
				}
			});
		});

		window.onpopstate = (e) => {
			_that.filter.buttons.forEach((element) => {
				element.classList.remove(_that.filter.active_class);
				element.classList.add(_that.filter.default_class);
			});

			if (e.state) {
				for (const key in e.state) {
					if (e.state.hasOwnProperty(key)) {
						e.state[key].forEach((filter_value) => {
							if (filter_value !== undefined && filter_value !== '') {
								const filter_buttons = Array.from(_that.filter.buttons).filter((element) => {
									return element.dataset.filter === key && element.dataset.filterValue === filter_value;
								});
								filter_buttons.forEach((element) => {
									element.classList.add(_that.filter.active_class);
								});
							}
						});
					}
				}

				_that.filterPhones(e.state);
			} else {
				const filter_buttons = Array.from(_that.filter.buttons).filter((element) => {
					return element.dataset.filterValue === '';
				});
				filter_buttons.forEach((element) => {
					element.classList.add(_that.filter.active_class);
				});
			}
		};
	}

	emitCallback(name, params = null) {
		let _that = this;

		if (typeof _that.callbacks[name] === 'function') {
			try {
				console.log('Phones::emitCallback(%o, %o)', name, params);
				_that.callbacks[name].call(this, params);
			} catch (e) {
				console.log(e);
			}
		} else {
			console.log('Phones::emitCallback(%o, %o) not defined', name, params);
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	try {
		new Phones({});
	} catch (error) {
		console.warn(error);
	}
});
